import { render, staticRenderFns } from "./DriversFieldEditForm.vue?vue&type=template&id=37c74a0e&scoped=true&"
import script from "./DriversFieldEditForm.vue?vue&type=script&lang=js&"
export * from "./DriversFieldEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DriversFieldEditForm.vue?vue&type=style&index=0&id=37c74a0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c74a0e",
  null
  
)

export default component.exports